"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BrixelProgressLineDots = props => {
  const {
    activeStep,
    backgroundSaturation = 100,
    barBackground = 'Light',
    className = '',
    classProgressBar = '',
    color = 'Primary',
    colorGoal = 'Green',
    goalValue = null,
    large = false,
    rounded = false,
    saturation = 400,
    saturationGoal = 400,
    showGoalValue = false,
    small = false,
    steps
  } = props;
  const dotsStep = [...Array(steps)].map((_, index) => index);
  const bgClass = barBackground ? `${barBackground.charAt(0).toUpperCase()}${barBackground.slice(1)}` : '';
  const classBackground = barBackground ? `bg${bgClass}${backgroundSaturation > 50 ? backgroundSaturation : ''}` : '';
  const colorClass = color ? `${color.charAt(0).toUpperCase()}${color.slice(1)}` : '';
  const classColor = color ? `bg${colorClass}${saturation > 50 ? saturation : ''}` : '';
  const txtClassColor = color ? `txt${colorClass}${saturation > 50 ? saturation : ''}` : '';
  const colorClassGoal = colorGoal ? `${colorGoal.charAt(0).toUpperCase()}${colorGoal.slice(1)}` : '';
  const classColorGoal = colorGoal ? `bg${colorClassGoal}${saturationGoal > 50 ? saturationGoal : ''}` : '';
  const classRounded = rounded ? 'brdRadius' : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "progressBarLineDots",
    className: `w-perc-100 ${classProgressBar}`,
    style: {
      height: `${large ? '4px' : ''} ${small ? '2px' : ''}`
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `${classBackground} ${classRounded} pos-r dis-f a-c jc-b`,
    style: {
      height: `${large ? '4px' : ''} ${small ? '2px' : ''}`
    }
  }, dotsStep.map((step, i) => (/*#__PURE__*/_react.default.createElement("span", {
    key: `dotStp_${i.toString()}`,
    className: `brdCircle w-fix-8 h-fix-8 dis-b pos-r zIndex6 ${step <= activeStep ? classColor : 'bgText100'}`
  }))), /*#__PURE__*/_react.default.createElement("span", {
    className: `activeProgBar dis-b ${className} ${classColor} ${classRounded}`,
    style: {
      width: `${activeStep * 100 / (steps - 1)}%`,
      height: `${large ? '4px' : ''} ${small ? '2px' : ''}`
    }
  }), goalValue && (/*#__PURE__*/_react.default.createElement("span", {
    className: `goalProgBar pos-r dis-b ${className} ${classColorGoal} ${classRounded}`,
    style: {
      width: `${goalValue}%`,
      height: `${large ? '4px' : ''} ${small ? '2px' : ''}`
    }
  }))), showGoalValue && (/*#__PURE__*/_react.default.createElement("span", {
    className: `goalValue txtGreen400 fsize-200 ff-mono ${txtClassColor}`,
    style: {
      left: `${goalValue}%`
    }
  }, goalValue, "%")));
};
var _default = exports.default = BrixelProgressLineDots;